import { h } from 'preact';
import * as BaseComp from 'components/shared/dynamicPageLoader/dynamicPageLoader.js';
// import s from 'components/shared/dynamicPageLoader/dynamicPageLoader.sss';
import Store from 'store/store';

export default class DynamicPageLoader extends BaseComp.default {
	componentDidUpdate(prevProps, prevState) {
		if (typeof super.componentDidUpdate === 'function') {
			super.componentDidUpdate(prevProps, prevState);
		}
		if (this.state.activeKey !== prevState.activeKey) {
			Store.emit('UPDATED_PAGE_LOADER_COMPONENT');
		}
	}
}
